import type { DashboardPeriod } from './service/types';

export interface DashboardRouteSearch {
  period: DashboardPeriod;
  from?: string;
  to?: string;
}

function parsePeriod(value: unknown): DashboardPeriod {
  if (value === 'today' || value === 'yesterday' || value === '7d' || value === '30d') {
    return value;
  }
  if (value === 'custom') {
    return 'custom';
  }
  return 'today';
}

function hasValidCustomRange(from: string | undefined, to: string | undefined): boolean {
  if (!from || !to) return false;
  const fromMs = Date.parse(from);
  const toMs = Date.parse(to);
  return !Number.isNaN(fromMs) && !Number.isNaN(toMs) && fromMs <= toMs;
}

export function validateDashboardSearch(search: Record<string, unknown>): DashboardRouteSearch {
  const period = parsePeriod(search.period);
  const from = typeof search.from === 'string' ? search.from : undefined;
  const to = typeof search.to === 'string' ? search.to : undefined;

  if (period === 'custom') {
    if (hasValidCustomRange(from, to)) {
      return { period, from, to };
    }

    return { period: 'today' };
  }

  return { period };
}

export function dashboardLoaderDeps(search: DashboardRouteSearch) {
  if (search.period !== 'custom') {
    return {
      period: search.period,
      from: undefined,
      to: undefined,
    };
  }

  return {
    period: search.period,
    from: search.from,
    to: search.to,
  };
}
